export const adminMenu = [
    {
        title: "Dashboard",
        url: "/dashboard",
        icon: "bi bi-grid-fill",
    },
     {
        title: "Enquiry",
        url: "/enquiry",
        icon: "bi bi-patch-question", 
    },
    {
        title: "Reports",
        url: "#",
        icon: "bi bi-clock-history",
        submenu: [
             {
                title: "Pay Collection",
                url: "report/pay-collection",
                icon: "bi bi-currency-rupee",
            },
            {
                title: "Attendance",
                url: "report/attendance",
                icon: "bi bi-calendar3",
            }
        ],
    },
    {
        title: "Catagory",
        url: "/course/category",
        icon: "bi bi-tag",
    },
    {
        title: "Course",
        url: "/course",
        icon: "bi bi-mortarboard",
    },
     {
        title: "Batch",
        url: "/batch/list",
        icon: "bi bi-ui-checks-grid",
    },
    {
        title: "Attendance History",
        url: "/attendance/history",
        icon: "bi bi-calendar2-check",
    },
    {
        title: "Admin Users",
        url: "/admin/user/list",
        icon: "bi bi-person-fill",
    },
    {
        title: "Faculty Users",
        url: "/faculty/user/list",
        icon: "bi bi-people",
    },
    {
        title: "Student",
        url: "/student/list",
        icon: "bi bi-people",
    },
];

